export const cookiesPostfix = {
  Mock: 'mk',
  Login: 'li',
  LoginWithAmazon: 'LWA_li',
  Refresh: 'refresh_exp', // use expiration token because refresh cookie is http-only
  Access: 'access_exp', // use expiration token because access cookie is http-only
  Employee: 'emp' // by employee here we mean an employee which is logged in by poslogon
}
